import { LanguageIso } from '@mkp/shared/models';
import { createAction, props } from '@ngrx/store';

export const switchAppLanguage = createAction(
  '[App Header] Switch App Language',
  props<{ languageIso: LanguageIso }>()
);
